import axios from 'axios';

export default {
    // TEST_EVENT (context, value) {
    //     context.commit('TEST_EVENT', value)
    // },
    // FETCH_EVENTS ({commit, dispatch}, payload){
    //   return new Promise((resolve, reject) => {
    //     commit('TOGGLE_LOADING', true);
    //     // axios.post('login/authenticate', payload)
    //     axios.get('events')
    //       .then((response) => {
    //         const { data: { data } } = response;
    //         localStorage.setItem('events', JSON.stringify(data));
    //         commit('TOGGLE_LOADING', false);
    //         resolve(data);
    //
    //       })
    //       .catch((error) => {
    //         console.log('action fetch error : ', error);
    //         reject(error);
    //         commit('TOGGLE_LOADING', false);
    //       });
    //   })
    // },
}



// WEBPACK FOOTER //
// ./src/store/modules/test/actions.js